export default __webpack_public_path__ + "static/media/plant.d5466505.svg";